module.exports = __webpack_public_path__ + "img/belgium.1d612a7a.svg";